import { apiSlice } from "../api/apiSlice";

const projectsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProjects: builder.query({
      query: (email) => `/projects?teamMembers_like=${email}`,
    }),
    addProject: builder.mutation({
      query: ({ data }) => ({
        url: "/projects",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        const response = await queryFulfilled;
        const { data: project } = response;
        dispatch(
          apiSlice.util.updateQueryData(
            "getProjects",
            project.creator,
            (draft) => {
              draft.push(project);
            }
          )
        );
      },
    }),
    deleteProject: builder.mutation({
      query: ({ id, creator }) => ({
        url: `/projects/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted({ id, creator }, { dispatch }) {
        //optimistic update
        dispatch(
          apiSlice.util.updateQueryData(
            "getProjects",
            creator?.email,
            (draft) => {
              return draft.filter((project) => project.id !== id);
            }
          )
        );
      },
    }),
    changeProjectStatus: builder.mutation({
      query: ({ id, data, user }) => ({
        url: `/projects/${id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted({ id, data, user }, { queryFulfilled, dispatch }) {
        dispatch(
          apiSlice.util.updateQueryData("getProjects", user?.email, (draft) => {
            return draft.map((pro) => {
              if (id === pro.id) {
                return { ...pro, status: data?.status, date: data?.date };
              } else return pro;
            });
          })
        );
      },
    }),
  }),
});

export const {
  useGetProjectsQuery,
  useAddProjectMutation,
  useDeleteProjectMutation,
  useChangeProjectStatusMutation,
} = projectsApi;
